
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCCAcT3czZIIvzwsuj289NiNBTBYC-WbfI",
  authDomain: "painel-candidaturas-online.firebaseapp.com",
  projectId: "painel-candidaturas-online",
  storageBucket: "painel-candidaturas-online.firebasestorage.app",
  messagingSenderId: "426929332151",
  appId: "1:426929332151:web:92ba1e946ee4e838509232"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };